// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const LensDiscoverabilityLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityLabel"
        description="Lens discoverability label."
        defaultMessage="Lens Discoverability"
    />
);
LensDiscoverabilityLabel.displayName = "LensDiscoverabilityLabel";

export const LensDiscoverabilityRowTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityRowTooltip"
        description="Lens discoverability row tooltip."
        defaultMessage="Lens Discoverability Tooltip Placeholder"
    />
);
LensDiscoverabilityRowTooltip.displayName = "LensDiscoverabilityRowTooltip";

export const LensDiscoverabilityAddTags = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityAddTags"
        description="Lens discoverability add tags."
        defaultMessage="Add Tags"
    />
);
LensDiscoverabilityAddTags.displayName = "LensDiscoverabilityAddTags";

export const LensDiscoverabilityModalActionText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityModalActionText"
        description="Lens discoverability modal action text."
        defaultMessage="Save"
    />
);
LensDiscoverabilityModalActionText.displayName = "LensDiscoverabilityModalActionText";

export const LensDiscoverabilityModalCancelText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityModalCancelText"
        description="Lens discoverability modal cancel text."
        defaultMessage="Cancel"
    />
);
LensDiscoverabilityModalCancelText.displayName = "LensDiscoverabilityModalCancelText";

export const LensDiscoverabilityModalDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityModalDescription"
        description="Lens discoverability modal description."
        defaultMessage="Tags will enable your lenses to be discoverable at the right moment to users"
    />
);
LensDiscoverabilityModalDescription.displayName = "LensDiscoverabilityModalDescription";

export const LensDiscoverabilityTagsLabel = (props: { count: ReactNode; total: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityTagsLabel"
        description="Lens discoverability tags label."
        defaultMessage="Tags ({count}/{total})"
        values={props}
    />
);
LensDiscoverabilityTagsLabel.displayName = "LensDiscoverabilityTagsLabel";

export const LensDiscoverabilityTagsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityTagsTooltip"
        description="Lens discoverability tags tooltip."
        defaultMessage="Tags Tooltip Placeholder"
    />
);
LensDiscoverabilityTagsTooltip.displayName = "LensDiscoverabilityTagsTooltip";

export const LensDiscoverabilityDescriptionLabel = (props: { count: ReactNode; total: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityDescriptionLabel"
        description="Lens discoverability description label."
        defaultMessage="Description ({count}/{total} Characters)"
        values={props}
    />
);
LensDiscoverabilityDescriptionLabel.displayName = "LensDiscoverabilityDescriptionLabel";

export const LensDiscoverabilityDescriptionTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityDescriptionTooltip"
        description="Lens discoverability description tooltip."
        defaultMessage="Description Tooltip Placeholder"
    />
);
LensDiscoverabilityDescriptionTooltip.displayName = "LensDiscoverabilityDescriptionTooltip";

export const LensDiscoverabilityPlacesLabel = (props: { count: ReactNode; total: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityPlacesLabel"
        description="Lens discoverability places label."
        defaultMessage="Places ({count}/{total})"
        values={props}
    />
);
LensDiscoverabilityPlacesLabel.displayName = "LensDiscoverabilityPlacesLabel";

export const LensDiscoverabilityPlacesTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityPlacesTooltip"
        description="Lens discoverability places tooltip."
        defaultMessage="Places Tooltip Placeholder"
    />
);
LensDiscoverabilityPlacesTooltip.displayName = "LensDiscoverabilityPlacesTooltip";

export const LensDiscoverabilityDaysTimesHolidaysLabel = (props: {
    count: ReactNode;
    total: ReactNode;
}): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityDaysTimesHolidaysLabel"
        description="Lens discoverability days times holidays label."
        defaultMessage="Timeslots And Holidays ({count}/{total})"
        values={props}
    />
);
LensDiscoverabilityDaysTimesHolidaysLabel.displayName = "LensDiscoverabilityDaysTimesHolidaysLabel";

export const LensDiscoverabilityDaysTimesHolidaysTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensDiscoverability.components.lensDiscoverabilityDaysTimesHolidaysTooltip"
        description="Lens discoverability days times holidays tooltip."
        defaultMessage="Timeslots And Holidays Tooltip Placeholder"
    />
);
LensDiscoverabilityDaysTimesHolidaysTooltip.displayName = "LensDiscoverabilityDaysTimesHolidaysTooltip";

export const messages = defineMessages({
    lensDiscoverabilityTagsPlaceholder: {
        id: "apps.lensDiscoverability.components.lensDiscoverabilityTagsPlaceholder",
        description: "Lens discoverability tags placeholder.",
        defaultMessage: "Add up to 8 Tags for better discoverbility",
    },
    lensDiscoverabilityDescriptionPlaceholder: {
        id: "apps.lensDiscoverability.components.lensDiscoverabilityDescriptionPlaceholder",
        description: "Lens discoverability description placeholder.",
        defaultMessage: "Describe your lens for better discoverbility",
    },
    lensDiscoverabilityPlacesPlaceholder: {
        id: "apps.lensDiscoverability.components.lensDiscoverabilityPlacesPlaceholder",
        description: "Lens discoverability places placeholder.",
        defaultMessage: "Leave this blank if your lens works anywhere",
    },
    lensDiscoverabilityDaysTimesHolidaysPlaceholder: {
        id: "apps.lensDiscoverability.components.lensDiscoverabilityDaysTimesHolidaysPlaceholder",
        description: "Lens discoverability days times holidays placeholder.",
        defaultMessage: "Leave this blank if your lens works all the time",
    },
});
